import { createContext, useContext, useState } from "react";
import QuoteDialog from "@/components/QuoteDialog";

const QuoteContext = createContext(null);

export function QuoteProvider({ children }) {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState({});

  const openQuote = (data = {}) => { setPrefill(data); setOpen(true); };

  return (
    <QuoteContext.Provider value={{ openQuote }}>
      {children}
      <QuoteDialog open={open} onOpenChange={setOpen} prefill={prefill} />
    </QuoteContext.Provider>
  );
}

export const useQuote = () => useContext(QuoteContext);
